export default "__VITE_ASSET__bUUCG3d$__"